import { IEmbedConfig, IYTVideoAdTargetingConfig } from './types'
import { logger } from 'utils/system/logger'
import { objectToString } from 'utils/object'
import { IObjKeyValStrModels } from 'constants/interfaces'

export const MAXIMUM_TIME_TO_WAIT_FOR_PAGE_TARGETING_ATRIBUTES_IN_MILLI_SECONDS = 2000
export const LOCALSTORAGE_PPID_KEY = 'ppid'

/**
 * Get Ad Targeting Attributes
 */
const getAdTargeting = async (): Promise<IYTVideoAdTargetingConfig> => {
    return new Promise((resolve) => {
        const listener = listenToAdTargeting(resolve)
        if (Object.keys(window.ytVideoAdTargetingConfig).length) {
            resolve(window.ytVideoAdTargetingConfig)
        } else {
            window.addEventListener('yt_ad_targeting_load_event', listener)
            window.timeoutId = window.setTimeout(() => {
                window.removeEventListener(
                    'yt_ad_targeting_load_event',
                    listener
                )
                resolve({})
            }, MAXIMUM_TIME_TO_WAIT_FOR_PAGE_TARGETING_ATRIBUTES_IN_MILLI_SECONDS)
        }
    })
}

export const setAdConfigTargeting = (
    embedConfig: IEmbedConfig,
    obj: IObjKeyValStrModels
): IEmbedConfig => {
    if (
        embedConfig.adsConfig &&
        embedConfig.adsConfig.adTagParameters.cust_params
    ) {
        const custParam = embedConfig.adsConfig.adTagParameters.cust_params
        embedConfig.adsConfig.adTagParameters.cust_params = `${objectToString(
            obj,
            '%3D',
            '%26'
        )}%26${custParam}`
        return embedConfig
    }
    return embedConfig
}

const listenToAdTargeting = (
    resolve: (
        value:
            | IYTVideoAdTargetingConfig
            | PromiseLike<IYTVideoAdTargetingConfig>
    ) => void
): (() => void) => {
    return (): void => {
        window.clearTimeout(window.timeoutId)
        resolve(window.ytVideoAdTargetingConfig)
    }
}

export const getEmbedConfig = async ({
    channelId = '',
    autoNav = false
} = {}): Promise<IEmbedConfig> => {
    let pageAdTargets: IYTVideoAdTargetingConfig = {}
    try {
        pageAdTargets = await getAdTargeting()
    } catch (error) {
        logger('error', error)
    }

    let embedConfig: IEmbedConfig = {}
    if (Object.keys(pageAdTargets).length) {
        const { adUnit, adTargetingParams } = pageAdTargets
        embedConfig = {
            adsConfig: {
                adTagParameters: {
                    iu: adUnit,
                    cust_params: adTargetingParams,
                    ppid: localStorage.getItem(LOCALSTORAGE_PPID_KEY) || ''
                },
                nonPersonalizedAd: true
            }
        }
    }
    if (autoNav) {
        embedConfig.autonavRelatedVideos = true
        embedConfig.relatedChannels = [channelId]
    }
    return embedConfig
}
